/* TANVI ABOUT: the three full-width photos drift slower than the page (parallax), the same way as the
   CONTACT hero and the top page's statement photo. The image is taller than its frame (CSS .tv-ab-parallax),
   so the drift never shows an edge; the fades into #151515 are in theme.css. 2026-10-02 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var IDS = ['7f12ae85-b318-47e2-acbe-0c1492668c33', '4f1542d3-f274-4092-ae1e-05295306561e', '2016f35e-13a6-43d6-a76f-4f9b6005899f'];
  /* photos that must stay whole (not enlarged): they drift less. The flower's ground is black like its section, so no edge shows. */
  var WHOLE = { '4f1542d3-f274-4092-ae1e-05295306561e': 0.035 };
  var items = [];
  IDS.forEach(function (id) {
    var sec = document.querySelector('.shopify-section[id$="__' + id + '"]');
    var img = sec && sec.querySelector('img');
    var frame = img && img.parentElement;
    if (!img || !frame || frame.getAttribute('data-tv-parallax')) return;
    frame.setAttribute('data-tv-parallax', '1');
    frame.classList.add('tv-ab-parallax');
    if (WHOLE[id]) frame.classList.add('tv-ab-parallax--whole');
    items.push({ frame: frame, img: img, k: WHOLE[id] || 0.1 });
  });
  if (!items.length) return;
  var ticking = false;
  function move() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    items.forEach(function (it) {
      var r = it.frame.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2); /* 1 = entering from below, -1 = leaving at the top */
      if (p > 1) p = 1; else if (p < -1) p = -1;
      it.img.style.transform = 'translate3d(0,' + (-p * r.height * it.k).toFixed(1) + 'px,0)';
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(move); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  move();
})();
